interface SocialSettings {
  appId: String;
  engageDomain: String
  providersIconPath: String
  providers: Array<string>;
  widgetType: String;
  useRedirect?: boolean;
};

class CESAppInfo {
  apiKey!: string;
  host!: string;
  endpoint!: string;
  locale!: string;
  ciamClientId!: string;
  reCaptchakey?: string;
  reCaptchaVer!: string;
  bundlePath?: string;
  cdnBaseUrl!: string;
  experienceName?: string;
  socialSettings!: SocialSettings;
  apiBaseUrl!: string;
  basicAuth!: string;
};

export default new CESAppInfo();
